var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Button',{staticClass:"code-btn",attrs:{"type":"text","id":"captcha-button","disabled":!_vm.isPhoneNumberValid || _vm.isSending}},[_vm._v(_vm._s(_vm.isSending ? `${_vm.countdown}秒重新发送` : '发送验证码'))]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSending),expression:"!isSending"}],attrs:{"id":"captcha-element"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }